import { Injectable } from '@angular/core';

declare var moment: any;

@Injectable()
export class DateTimeService {
  offset: { string: string, value: number } = { string: '', value: 0 };

  constructor() {
    let rawOffset = new Date().toString().split('GMT')[1].split(' ')[0];
    this.offset.value = new Date().getTimezoneOffset() / 60;
    this.offset.string = rawOffset.slice(0, 3) + ':' + rawOffset.slice(3, 5);
   }

  getNextHalfHour(): Date {
    let rounding = 30 * 60 * 1000;
    let nextHalf = moment(Math.ceil((+moment()) / rounding) * rounding);
    // console.log(nextHalf.toISOString());
    // console.log(moment(nextHalf.toISOString()).format());

    return nextHalf;
    // let dateString = this.splitISOToDate(nextHalf);
    // let timeString = this.splitISOToTime(nextHalf);

    // return this.concatDateAndTime(timeString, dateString);
  }

  getNextHour(dateString: any): Date {
    if (typeof dateString != 'string') dateString = dateString.toISOString();
    let nextHourDate = moment(this.splitISOToDate(dateString) + ' ' + this.splitISOToTime(dateString)).add(1, 'h').utc().format();

    return new Date(nextHourDate); // puts it back in the format we expect elsewhere
  }

  getDateForTimeString(time: string) {
    time = time.toLowerCase();

    // Look for a p or an a to determine time. If none specified, default to a.
    let am = time.includes('p') ? false : true;

    // Get a number to represent the time. Use the following scenarios:
    // 4 numbers: assume format is hh:mm
    // 3 numbers: assume format is h:mm
    // 2 numbers: assume format is hh
    // 1 number: assume format is h
    let timeNumbers = '';
    for (let i = 0; i < time.length; i++) {
      if (parseInt(time[i]) || time[i] === '0') timeNumbers += time[i];
    }

    let hours, minutes;
    switch (timeNumbers.length) {
      case 4:
        hours = timeNumbers.substr(0, 2);
        minutes = timeNumbers.substr(2, 2);
        break;
      case 3:
        hours = timeNumbers.substr(0, 1);
        minutes = timeNumbers.substr(1, 2);
        break;
      case 2:
      case 1:
        hours = timeNumbers;
        minutes = '00';
        break;
      default:
        return null;
    }

    // Now build the time string
    hours = parseInt(hours);
    minutes = parseInt(minutes);
    if (hours === 12) hours = 0;
    if (!am && hours < 12) hours += 12;

    let date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    return date;
  }

  // returns parsed time if it can, otherwise returns null
  // dateTimeString is because we need to keep up with DST status
  humanToIsoTimeFragment(stringToParse: string, dateTimeString: string) {
    console.log(dateTimeString);
    if (!stringToParse.length) {
      return '';
    }
    let dateFragment = this.splitISOToDate(dateTimeString);
    let timeString = stringToParse.toLowerCase();
    let isAfternoon: boolean = false;
    let minuteLessThanTen: boolean = false;
    if (!timeString.includes('am') && !timeString.includes('pm')) return null; // we're not supporting user-input military time right now
    if (timeString.includes('pm')) isAfternoon = true;

    if (!timeString.includes(':')) return null; // invalid format

    let timeParts = timeString.split(':');
    let hour = parseInt(timeParts[0], 10);
    if (timeParts[1][0] == '0') minuteLessThanTen = true;
    let minute = parseInt(timeParts[1], 10);

    if (timeParts[1][1] == ' ') return null; // we don't want to parse a date with a partial minute value
    if (isNaN(hour) || isNaN(minute)) return null; // if we don't even have a chance for a valid time we stop trying

    // converting to military time
    if (isAfternoon && hour < 12) hour += 12;
    else if (!isAfternoon && hour == 12) hour = 0;

    if (hour > 24) return null; // invalid format
    if (minute > 59) return null; // invalid format

    // add the other zeroes back in if we need 'em
    let hourStr = hour.toString();
    let minuteStr = minute.toString();
    if (hour < 10) hourStr = '0' + hourStr;
    if (minute < 10 && minuteLessThanTen) minuteStr = '0' + minuteStr;
    else if (minute < 10) minuteStr = minute + '0';

    let finalString = hourStr + ':' + minuteStr + ':00' + this.offset.string;
    console.log(finalString);
    console.log(moment(dateFragment + 'T' + finalString).toISOString());
    // finalString = '00:30:00' + this.offset.string;
    // console.log(finalString);
    // console.log(moment(dateFragment + 'T' + finalString).toISOString());

    return moment(dateFragment + 'T' + finalString).toISOString();
  }

  // expects full date string
  isoTimeFragmentToHuman(stringToParse: string) {
    return moment(stringToParse).format('LT');
  }

  splitISOToDate(dateString: any) {
    // because we accept strings or dates
    dateString = typeof dateString == 'string' ? dateString : dateString.toISOString();
    return dateString.split('T')[0];
  }

  splitISOToTime(dateString: any) {
    // because we accept strings or dates
    dateString = typeof dateString == 'string' ? dateString : dateString.toISOString();
    let timeString = dateString.split('T')[1];
    // if (!timeString.includes('.000Z')) timeString = timeString.split('-')[0] + '.000Z'; // we don't care about timezones
    return timeString;
  }

  concatDateAndTime(timeString: string, dateString: string): Date {
    if (timeString == '') timeString = '00:00:00.000Z';
    // we can pass full strings or fragments
    if (timeString.includes('T')) timeString = this.splitISOToTime(timeString);
    if (dateString.includes('T')) dateString = this.splitISOToDate(dateString);

    let newDate = dateString + 'T' + timeString;
    return new Date(newDate);
  }

  updateDate(newDate: string, oldDate: string) {
    let newMoment = moment(newDate);
    let oldMoment = moment(oldDate);
    let daysBetween = newMoment.diff(oldMoment, 'days');
    let newNewDate = oldMoment.add(daysBetween, 'days');
    // console.log(newMoment.format());
    // console.log(oldMoment.format());
    // console.log(daysBetween);
    // console.log(newNewDate.format());

  }

  updateTime(newTime: string, oldTime: string) {
    let newMoment = moment(newTime);
    let oldMoment = moment(oldTime);
    let daysBetween = newMoment.diff(oldMoment, 'minutes');
    let newNewDate = oldMoment.add(daysBetween, 'minutes');
    // console.log(newMoment.format());
    // console.log(oldMoment.format());
    // console.log(daysBetween);
    // console.log(newNewDate.format());
  }

  checkOffset(timeToCheck: string) {
    // so we can parse full dates or time fragments
    let splitIndex = 8;
    if (timeToCheck.length > 16) splitIndex = 19;

    if (timeToCheck.slice(splitIndex, timeToCheck.length) == this.offset.string) return timeToCheck; // offset is correct
    return timeToCheck.slice(0, splitIndex) + this.offset.string;
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/services/date-time/date-time.service.ts